import { createAction } from '@reduxjs/toolkit';
import { IR225ReportRequest } from 'app/models/ReportPages/IR225Report';
import { IR448ReportRequest } from 'app/models/ReportPages/IR448Report';

const getR225ReportDetails = createAction<IR225ReportRequest>('GET_R225_REPORT_DETAILS');
const getR448ReportDetails = createAction<IR448ReportRequest>('GET_R448_REPORT_DETAILS');

export const serviceActions = { getR225ReportDetails,getR448ReportDetails };
